import React from 'react';

function GroupifyReflection() {
    return(
        <section className="sunney-problem">
        <h2>Reflection</h2>
        
        <h3>Lessons Learned</h3>
        <p>
        This project taught us that <strong>"reinvention is not always the answer"</strong>. The team realized that <strong>highly inventive designs can lose users</strong>, 
        while <strong>empathetic improvements to existing workflows are often more powerful</strong>. Our pivot from the Navigator island interface 
        to the simpler Groupify event list demonstrated that sometimes the best innovation is knowing when to simplify rather than 
        complicate.
        </p>
        <p>
        We also learned the importance of <strong>testing with the actual target audience</strong>. Early feedback from international and 
        first-generation students revealed that our initial design assumptions didn't align with their needs. The English naming 
        conventions and complex metaphors created barriers rather than bridges, reinforcing the need for inclusive, accessible design.
        </p>
        <p>
        Most importantly, we discovered that <strong>addressing social isolation requires understanding the nuanced barriers</strong> that different 
        student populations face. Features like flexible scheduling and automatic messaging weren't just nice-to-haves, they were 
        essential for creating a platform that truly serves students who are already overwhelmed by academic and social pressures.
        </p>

        <h3>Next Steps</h3>
        <p>
        Future iterations would include:
        </p>
        <ul>
            <li>⟡ <strong>Deeper user testing</strong> specifically with international/first-generation students to hone features that address their unique cultural and academic barriers</li>
            <li>⟡ Explore <strong>cultural sensitivity features</strong> that help bridge communication gaps and make events more welcoming to diverse student populations</li>
            <li>⟡ Develop <strong>co-op integration</strong> features that help students maintain connections during work rotations</li>
            <li>⟡ Test <strong>recommendation algorithms</strong> to better match students with events based on interests, schedule, and social preferences</li>
            <li>⟡ Build out <strong>accessibility features</strong> to ensure the app is usable for all students regardless of ability or language proficiency</li>
            <li>⟡ Conduct <strong>longitudinal studies</strong> to understand how Groupify impacts students' sense of belonging over time</li>
        </ul>
        <p>
        This project reinforced our commitment to <strong>human-centered design</strong> that prioritizes real user needs over flashy innovations. 
        Creating a space where students can find belonging without added pressure feels meaningful and impactful, especially for 
        those who need it most.
        </p>
    </section>
    );
}

export default GroupifyReflection;
